import React from "react";
import * as FileSaver from "file-saver";
import XLSX from "sheetjs-style";
import Button from "@mui/material/Button";
import VerticalAlignTopIcon from "@mui/icons-material/VerticalAlignTop";
import FileDownloadIcon from '@mui/icons-material/FileDownload';
const Exportuserwise = ({ excelData, fileName, title }) => {
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset-UTF-8";
  const fileExtension = ".xlsx";

  const exportTOExcel = async () => {
    const transformedData = transformData(excelData);
    const ws = XLSX.utils.json_to_sheet(transformedData);

    // Apply column widths
    const wscols = [
      { wch: 15 }, // Group Name
      { wch: 25 }, // Report Name
      { wch: 30 }, // Email
      { wch: 15 }, // Date
    ];
    ws["!cols"] = wscols;

    // Create workbook and export
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  };

  const transformData = (data) => {
    const transformed = [];
    function formatDate(date) {
      const [year, month, day] = date.split('-'); // Split the date string into year, month, and day
      return `${day}-${month}-${year}`; // Return in dd-mm-yyyy format
    }
    data.forEach((group) => {
      group.reportViews.forEach((report) => {
        transformed.push({
          "Group Name": group.groupName,
          "Report Name": report.reportName,
          Email: report.email,
          Date: report && report.date && formatDate(report.date),
        });
      });
    });

    return transformed;
  };

  return (
    <div>
      <Button
        style={{
          backgroundColor: "#a70e13",
          fontSize: "14px",
          color: "#ffffff",
          padding: "10px",
          borderRadius: "6px",
        }}
        onClick={exportTOExcel}
        className="export-button"
      >
        <FileDownloadIcon className="export-icon" />
        {title}
      </Button>
    </div>
  );
};

export default Exportuserwise;
